module.exports = __webpack_public_path__ + "static/media/sembcorp.75a8667a.png";